export default function TreatmentsHero() {
  return (
    <section className="relative h-[60vh] w-full overflow-hidden mt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-sand via-bone to-gold/10">
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M200,500 Q400,300 600,500 T1000,500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-gold"
            />
            <circle cx="300" cy="400" r="150" fill="currentColor" className="text-gold/20" />
            <circle cx="700" cy="600" r="200" fill="currentColor" className="text-greige/20" />
          </svg>
        </div>
      </div>

      <div className="relative h-full flex items-center justify-center">
        <div className="text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light tracking-[0.15em] text-charcoal mb-6">
            Our Signature Drips
          </h1>
          <p className="text-xl md:text-2xl font-serif text-gold tracking-wide">
            Tailored IV Hydration for Peak Performance &amp; Radiance
          </p>
        </div>
      </div>
    </section>
  );
}
